export enum MissingItem {
  Car = 'bil',
  Customer = 'kunde',
  Offer = 'tilbud',
}
